import React from "react";

export const ChatAiPrivacy = () => {
  return (
    <div id="chat-ai-privacy">
      <header className="chat-ai-privacy-page-header">
        <div className="container">
          <h1>AI chat privacy notice</h1>
          <p className="chat-ai-privacy-updated">Last updated: April 22, 2026</p>
        </div>
      </header>

      <div className="translations-content-container">
        <div className="container">
          <div className="tab-content translations-content-item en visible" id="en">
            <p>
              This notice describes how our web application handles information when you use the
              built-in AI chat feature. By using AI chat, you agree to this notice.
            </p>

            <h2>AI output and mistakes</h2>
            <p>
              Responses are generated by artificial intelligence and may be incorrect, incomplete,
              or outdated. AI can make mistakes. You should not rely on AI chat as a sole source of
              truth for important decisions. Always verify critical information from authoritative
              sources.
            </p>

            <h2>Not professional advice</h2>
            <p>
              AI chat does not provide legal, medical, financial, or other professional advice. If
              you need qualified guidance, consult an appropriate professional.
            </p>

            <h2>What we store</h2>
            <p>
              We do not use AI chat to collect or retain private personal information about you for
              profiling or marketing. To recognize the same browser session and keep the chat
              experience consistent, we may store a <strong>session identifier</strong> only. That
              identifier is not intended to identify you as an individual beyond tying messages to
              the same session.
            </p>

            <h2>Your messages</h2>
            <p>
              What you type is sent only as needed to produce a reply and is not kept as a
              long-term record of private information on our side. Where we use a third-party AI
              service, that provider may handle the request under its own terms for the duration
              needed to return a response. If our practices change in a material way, we will update
              this notice.
            </p>

            <h2>Security</h2>
            <p>
              We take reasonable measures to protect information handled by the service. No method
              of transmission or storage over the internet is completely secure.
            </p>

            <h2>Children</h2>
            <p>
              The service is not directed at children under 13. If you believe a child has provided
              personal information through AI chat, please contact us so we can take appropriate
              steps.
            </p>

            <h2>Links and third parties</h2>
            <p>
              Our application may link to other sites. We are not responsible for the privacy
              practices of third-party websites or services, including AI infrastructure providers.
              Review their policies separately.
            </p>

            <h2>Changes</h2>
            <p>
              We may update this notice from time to time. The &quot;Last updated&quot; date at the
              top will be revised when we do. Continued use of AI chat after changes constitutes
              acceptance of the updated notice, to the extent permitted by law.
            </p>

            <h2>Contact</h2>
            <p>
              If you have questions about this AI chat privacy notice, contact us through the same
              channels you use for general inquiries about this website.
            </p>
          </div>
        </div>
      </div>

      <div className="footer">
        <div className="container" />
      </div>
    </div>
  );
};
